import * as React from 'react';
import { SVGProps } from 'react';

const IconMGRPSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.614 4.5H1v1h10v-1H7.08l-.913-1.086.38-1.38L5.5 1l.333 1.034L4.5 3.414 4.614 4.5ZM11 6.5H1v1h3.92l.913 1.086-.38 1.38L6.5 11l-.333-1.034L7.5 8.586 7.386 7.5H11v-1Z" />
  </svg>
);
export default IconMGRPSizeXs;
